// Unique Id
const existingIDs = [];

const getRandomLetters = (length = 1) =>
    Array(length)
        .fill()
        .map((e) => String.fromCharCode(Math.floor(Math.random() * 26) + 65))
        .join("");

const getRandomDigits = (length = 1) =>
    Array(length)
        .fill()
        .map((e) => Math.floor(Math.random() * 10))
        .join("");

const generateUniqueID = () => {
    let id = getRandomLetters(2) + getRandomDigits(4);
    while (existingIDs.includes(id)) {
        id = getRandomLetters(2) + getRandomDigits(4);
    }
    existingIDs.push(id);
    return id;
};
// Unique Id

export default generateUniqueID;